import React, { Component } from "react";
import { Bar, Radar } from "react-chartjs-2";
import { Pie } from "react-chartjs-2";
import { Doughnut } from "react-chartjs-2";
import { Line } from "react-chartjs-2";
import { PolarArea } from "react-chartjs-2";
import axios from "axios";
import {
  Chart as ChartJS,
  RadialLinearScale,
  LinearScale,
  CategoryScale,
  PointElement,
  LineElement,
  BarElement,
  Legend,
  ArcElement,
  Title,
  Tooltip,
  Filler,
} from "chart.js";
import { Card, Col, Row } from "react-bootstrap";
import configData from "../config.json";

import LoadingOverlay from "./LoadingOverlay";
// import Areachart from './Charts/Areachart';
// import Horizontalchart from './Charts/Horizontalchart';
ChartJS.register(
  LinearScale,
  RadialLinearScale,
  CategoryScale,
  PointElement,
  LineElement,
  BarElement,
  Legend,
  ArcElement,
  Title,
  Tooltip,
  Filler
);

export default class DashboardCharts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      loading: true,
      data: {
        labels: [],
        datasets: [],
        sId: sessionStorage.getItem("sessionId"),
        uId: sessionStorage.getItem("uId"),
      },
    };
  }
  componentDidMount() {
    this.fetchEmployeeData();
  }

  fetchEmployeeData = () => {
    this.setState({ loading: true });
    let apiName = [];
    let apiComp = [];
    var formData = new FormData();
    formData.append("sId", this.state.data.sId);
    formData.append("uId", this.state.data.uId);
    
    fetch(configData.api_url + "C_Employees/list", {
      method: "POST",
      mode: "cors", 
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data.status === "success" && Array.isArray(data.list)) {
          for (const dataObj of data.list) {
            // Validate data exists before pushing
            if (dataObj.fName) {
              apiName.push(dataObj.fName);
            }
            if (dataObj.mobile) {
              apiComp.push(dataObj.mobile);
            }
          }

          // Update the state with the new data
          this.setState({
            data: {
              ...this.state.data,
              labels: apiName,
              datasets: [
                {
                  label: "Employee Mobile Numbers",
                  data: apiComp,
                  fill: false,
                  borderColor: [
                    "rgba(255, 99, 132, 1)",
                    "rgba(54, 162, 235, 1)",
                    "rgba(255, 206, 86, 1)",
                    "rgba(75, 192, 192, 1)",
                    "rgba(153, 102, 255, 1)",
                  ],
                  backgroundColor: [
                    "rgba(255, 99, 132, 0.2)",
                    "rgba(54, 162, 235, 0.2)",
                    "rgba(255, 206, 86, 0.2)",
                    "rgba(75, 192, 192, 0.2)",
                    "rgba(153, 102, 255, 0.2)",
                  ],
                  borderWidth: 1,
                  hoverOffset: 20,
                },
              ],
            },
            loading: false,
          });
        } else {
          console.error("Failed to load employee data:", data.message);
          // Set empty data to prevent chart errors
          this.setState({
            data: {
              ...this.state.data,
              labels: [],
              datasets: [{
                label: "No Data Available",
                data: [],
                backgroundColor: ["rgba(255, 99, 132, 0.2)"],
                borderColor: ["rgba(255, 99, 132, 1)"],
                borderWidth: 1,
              }],
            },
            loading: false,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching employee data:", error);
        // Set empty data to prevent chart errors
        this.setState({
          data: {
            ...this.state.data,
            labels: [],
            datasets: [{
              label: "Error Loading Data",
              data: [],
              backgroundColor: ["rgba(255, 99, 132, 0.2)"],
              borderColor: ["rgba(255, 99, 132, 1)"],
              borderWidth: 1,
            }],
          },
          loading: false,
        });
      });
  };
  render() {
    if (this.state.loading) {
      return (
        <div className="text-center p-4">
          <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading charts...</span>
          </div>
          <p className="mt-2">Loading chart data...</p>
        </div>
      );
    }

    return (
      <div>
        <Row className="g-3">
          <Col xs={12} sm={6} md={4} lg={4} className="mb-2">
            <Card className="h-100">
              <Card.Body className="d-flex justify-content-center align-items-center">
                <Bar
                  data={this.state.data}
                  options={{
                    responsive: true,
                    maintainAspectRatio: true,
                  }}
                />
              </Card.Body>
            </Card>
            <p className="text-center"><b>Bar chart</b></p>
          </Col>
          <Col xs={12} sm={6} md={4} lg={4} className="mb-2">
            <Card className="h-100">
              <Card.Body className="d-flex justify-content-center align-items-center">
                <Pie
                  data={this.state.data}
                  options={{
                    responsive: true,
                    maintainAspectRatio: true,
                  }}
                />
              </Card.Body>
            </Card>
            <p className="text-center "><b>Pie chart</b></p>
          </Col>
          <Col xs={12} sm={6} md={4} lg={4} className="mb-2">
            <Card className="h-100">
              <Card.Body className="d-flex justify-content-center align-items-center">
                <Doughnut
                  data={this.state.data}
                  options={{
                    responsive: true,
                    maintainAspectRatio: true,
                  }}
                />
              </Card.Body>
            </Card>
            <p className="text-center "><b>Doughnut chart</b></p>
          </Col>
        </Row>
        <Row className="g-3 mt-2">
          <Col xs={12} sm={6} md={4} lg={4} className="mb-2">
            <Card className="h-100">
              <Card.Body className="d-flex justify-content-center align-items-center">
                <div style={{ minHeight: "200px", display: "flex", alignItems: "center" }}>
                  <p className="text-muted">Horizontal Chart Coming Soon</p>
                </div>
              </Card.Body>
            </Card>
            <p className="text-center "><b>Horizontal chart</b></p>
          </Col>
          <Col xs={12} sm={6} md={4} lg={4} className="mb-2">
            <Card className="h-100">
              <Card.Body className="d-flex justify-content-center align-items-center">
                <Line 
                  data={this.state.data}
                  options={{
                    responsive: true,
                    maintainAspectRatio: true,
                  }}
                />
              </Card.Body>
            </Card>
            <p className="text-center"><b>Line chart</b></p>
          </Col>
          <Col xs={12} sm={6} md={4} lg={4} className="mb-2">
            <Card className="h-100">
              <Card.Body className="d-flex justify-content-center align-items-center">
                <div style={{ minHeight: "200px", display: "flex", alignItems: "center" }}>
                  <p className="text-muted">Area Chart Coming Soon</p>
                </div>
              </Card.Body>
            </Card>
            <p className="text-center"><b>Area chart</b></p>
          </Col>
        </Row>
        <Row className="g-3 mt-2">
          <Col xs={12} sm={6} md={4} lg={4} className="mb-2">
            <Card className="h-100">
              <Card.Body className="d-flex justify-content-center align-items-center">
                <PolarArea 
                  data={this.state.data}
                  options={{
                    responsive: true,
                    maintainAspectRatio: true,
                  }}
                />
              </Card.Body>
            </Card>
            <p className="text-center"><b>Polar Area chart</b></p>
          </Col>
          <Col xs={12} sm={6} md={4} lg={4} className="mb-2">
            <Card className="h-100">
              <Card.Body className="d-flex justify-content-center align-items-center">
                <Radar 
                  data={this.state.data}
                  options={{
                    responsive: true,
                    maintainAspectRatio: true,
                  }}
                />
              </Card.Body>
            </Card>
            <p className="text-center"><b>Radar chart</b></p>
          </Col>
        </Row>
      </div>
    );
  }
}
